import React from "react";

interface CircleButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
  outerBgColor?: string; // 外层背景色
  innerBgColor?: string; // 内层背景色
  textColor?: string; // 文字颜色
  className?: string; // 额外的样式类
}

const CircleButton: React.FC<CircleButtonProps> = ({
  children,
  onClick,
  disabled = false,
  title,
  outerBgColor = "bg-[rgba(152,119,255,0.2)]", // 默认外层背景色
  innerBgColor = "bg-gradient-to-r from-[#4E8FFD] to-[#A785F5]", // 默认内层背景色
  textColor = "text-white", // 默认文字颜色
  className = "",
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={`w-10 h-10 ${outerBgColor} rounded-full p-1 ${className}`}
    >
      <div className={`w-full h-full flex items-center justify-center rounded-full ${innerBgColor}`}>
        <span className={textColor}>{children}</span>
      </div>
    </button>
  );
};

export default CircleButton;